import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

/**
 * AuthGuard for protecting routes
 * Overridden from source -https://github.com/auth0/auth0-angular/blob/master/projects/auth0-angular/src/lib/auth.guard.ts
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private auth: AuthService) {}

  private readonly returnUrlKey = 'pme:returnUrl';

  canLoad(_route: Route, _segments: UrlSegment[]): Observable<boolean> {
    return this.auth.isAuthenticated$.pipe(take(1));
  }

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.redirectIfUnauthenticated(state);
  }

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.redirectIfUnauthenticated(state);
  }

  private redirectIfUnauthenticated(state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.isAuthenticated$.pipe(
      tap((loggedIn) => {
        const isInviteLink = state.url.includes('invitation=');

        if (isInviteLink) {
          this.auth.loginWithRedirect({
            appState: {
              target: state.url.split('?')[0]
            },
            authorizationParams: {
              invitation: state.url.split('invitation=')[1].split('&')[0],
              organization: state.url.split('organization=')[1].split('&')[0],
              connection: 'ATS-AAD'
            }
          });
        } else if (!loggedIn) {
          sessionStorage.setItem(this.returnUrlKey, state.url || '/');

          this.auth.loginWithRedirect({
            appState: {
              target: state.url
            },
            authorizationParams: {
              organization: 'ats',
              connection: 'ATS-AAD'
            }
          });
        }
      })
    );
  }
}
